import http from '../../src/api/axiosConfig'

class ManageReclamation {

    prefix = '/v1/web/reclamation/'

    loadAllReclamations() {
        return http.get(this.prefix + 'all')
    }

    validateReclamation(data) {
        return http.post(this.prefix + 'validate', data)
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ManageReclamation()
